import { PublicKey } from "@solana/web3.js";
import { serialize, deserializeUnchecked } from "borsh";
import { u64 } from "../utils";
import { HapiAccountType } from "./enums";
class CommunityState {
    constructor(object) {
        Object.assign(this, object);
    }
}
CommunityState.schema = new Map([
    [
        CommunityState,
        {
            kind: "struct",
            fields: [
                ["account_type", "u8"],
                ["authority", [32]],
                ["next_case_id", "u64"],
                ["name", "string"],
            ],
        },
    ],
]);
CommunityState.size = 73;
export class Community {
    constructor(data) {
        /// HAPI account type
        this.accountType = HapiAccountType.Community;
        if (data) {
            this.authority = data.authority;
            this.nextCaseId = data.nextCaseId;
            this.name = data.name;
        }
    }
    static async getAddress(programId, communityName) {
        return PublicKey.findProgramAddress(Community.getAddressSeeds(communityName), programId);
    }
    static getAddressSeeds(communityName) {
        return [Buffer.from("community"), Buffer.from(communityName)];
    }
    static fromState(state) {
        return new Community({
            authority: new PublicKey(state.authority),
            nextCaseId: new u64(state.next_case_id),
            name: state.name,
        });
    }
    static deserialize(buffer) {
        return Community.fromState(deserializeUnchecked(CommunityState.schema, CommunityState, buffer));
    }
    static async retrieve(programId, connection, communityName) {
        const [communityAddress] = await Community.getAddress(programId, communityName);
        const communityAccount = await connection.getAccountInfo(communityAddress);
        if (!communityAccount) {
            throw new Error(`Community not found: ${communityName} (${communityAddress})`);
        }
        return {
            data: Community.deserialize(communityAccount.data),
            account: communityAddress,
        };
    }
    serialize() {
        const buf = Buffer.alloc(CommunityState.size);
        buf.set(serialize(CommunityState.schema, this.toState()));
        return buf;
    }
    toState() {
        return new CommunityState({
            account_type: this.accountType,
            authority: this.authority.toBytes(),
            next_case_id: this.nextCaseId,
            name: this.name,
        });
    }
}
Community.size = CommunityState.size;
//# sourceMappingURL=community.js.map